<!--TODO Remove unnecessary duplicated requests, refactor the components like removing the duplicated modal both in Home.vue and MobileAndTabletMenu.vue (this commit changes)-->
<template>
  <div class="mobile-menu">
    <div class="d-flex j-center a-center">
      <button class="pl-16 d-none" @click="isNavDrawerOpen = !isNavDrawerOpen">
        <img src="@/assets/images/icons/mobil-menu.svg" />
      </button>
      <span v-if="!isMobile" class="mr-auto pl-16">
        Mağaza Yönetim Paneli
      </span>
    </div>
    <button class="mobile-menu-logo">
      <img src="@/assets/images/icons/n11-logo.svg" />
    </button>
    <div class="d-flex j-center a-center">
      <a href="/selleroffice/app/notifications" class="ml-auto pr-16" :class="{ 'ml-0': isMobile }">
        <img src="@/assets/images/icons/mobil-notification.svg" />
      </a>
      <button
        v-if="!isMobile"
        @click="isSideAreaDrawerOpen = !isSideAreaDrawerOpen"
        class="pr-16"
      >
        <img src="@/assets/images/icons/tablet-col.svg" />
      </button>
    </div>
  </div>
  <div class="drawer-blur" v-if="isNavDrawerOpen || isSideAreaDrawerOpen" />
  <div class="nav-drawer" v-show="isNavDrawerOpen">
    <div v-for="(item, index) in sideNavItems" :key="index">
      <div class="background">
        <a class="menu-item" href="#">{{ item }}</a>
        <img class="image-arrow" src="@/assets/images/icons/mobil-arrow.svg" />
      </div>
      <div class="hr m-0"></div>
    </div>
  </div>
  <div class="side-area-drawer" v-show="isSideAreaDrawerOpen">
    <div class="side-area">
      <div class="shop-profile-card">
        <slot name="shopProfileSlot"></slot>
      </div>
      <div class="shop-performance-card">
        <slot name="shopPerformanceSlot"></slot>
      </div>
      <!-- <div class="announcements">
        <div class="rectangle-card"></div>
      </div> -->
      <div class="details-banner-area">
        <slot name="bannerSlot"></slot>
      </div>
      <slot name="surveySlot"></slot>
      <slot name="googleAdSlot"></slot>
    </div>
  </div>
  <!--TODO change with collapse component-->
  <div
    v-if="isMobile"
    class="profile-box"
    :class="{ opened: isProfileBoxOpen }"
    @click="!isProfileBoxOpen ? (isProfileBoxOpen = !isProfileBoxOpen) : null"
  >
    <div class="d-flex">
      <img
        class="profile-box-icon"
        v-show="isProfileBoxOpen"
        :src="shopProfileData.logo"
      />
      <div :class="{ 'd-flex': !isProfileBoxOpen }">
        <div class="d-flex">
          <p
            class="profile-box-title-position"
            :class="{ opened: isProfileBoxOpen }"
          >
            {{ shopProfileData.storeName }}
          </p>
          <img
            v-show="isProfileBoxOpen"
            class="profile-box-verificated-icon"
            src="@/assets/images/icons/verificated-shop-badge.svg"
          />
        </div>
        <div class="mt-10">
          <img
            v-show="isProfileBoxOpen"
            class="profile-box-seller-badge"
            src="@/assets/images/icons/seller-badge.svg"
          />
          <img
            v-show="isProfileBoxOpen"
            class="profile-box-cargo-icon"
            src="@/assets/images/icons/cargo.svg"
          />
        </div>
      </div>
    </div>
    <img
      class="profile-box-arrow"
      :class="{ opened: isProfileBoxOpen }"
      :src="
        require(`@/assets/images/${
          !isProfileBoxOpen ? 'arrow-down.svg' : 'arrow-up.svg'
        }`)
      "
      @click.stop="isProfileBoxOpen = !isProfileBoxOpen"
    />
    <div v-show="isProfileBoxOpen" class="hr"></div>
    <p class="profile-box-shop-point-title" v-show="isProfileBoxOpen">
      Mağaza Puanı
    </p>
    <ProgressBar
      class="profile-box-progress-bar"
      v-show="isProfileBoxOpen"
      :rectangleValue="shopProfileData.sellerScore"
    />
  </div>
  <div
    v-if="isMobile"
    class="performance-box"
    :class="{ opened: isPerformanceBoxOpen }"
  >
    <div
      class="performance-box-header w-100 d-flex justify-between a-center"
      @click="isPerformanceBoxOpen = !isPerformanceBoxOpen"
    >
      <p class="performance-box-title-position">Performans</p>
      <img
        class="performance-box-arrow"
        :src="
          require(`@/assets/images/${
            isPerformanceBoxOpen ? 'arrow-up.svg' : 'arrow-down.svg'
          }`)
        "
      />
    </div>
    <slot v-if="isPerformanceBoxOpen" name="shopPerformanceSlot"></slot>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { ProgressBar } from '@n11/so-ui-components';

export default {
  name: 'MobileAndTabletMenu',
  components: {
    ProgressBar,
  },
  props: {
    shopProfileData: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const sideNavItems = [
      'Ana Sayfa',
      'Ürün Yönetimi',
      'Ödeme ve Fatura Yönetimi',
      'Reklam Yönetimi',
      'Pazarlama Yönetimi',
      'İstatistikler',
    ];

    const isProfileBoxOpen = ref(false);
    const isPerformanceBoxOpen = ref(false);
    const isNavDrawerOpen = ref(false);
    const isSideAreaDrawerOpen = ref(false);
    const size = ref(window.innerWidth);

    const isMobile = computed(() => {
      return size.value < 768;
    });

    window.addEventListener(
      'resize',
      (event) => {
        size.value = event.target.innerWidth;
      },
      true,
    );

    return {
      sideNavItems,
      isProfileBoxOpen,
      isPerformanceBoxOpen,
      isNavDrawerOpen,
      isSideAreaDrawerOpen,
      size,
      isMobile,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/utilities.scss';

.mobile-menu {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: $colorN00;
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  &-logo {
    position: absolute;
    left: calc(50% - 48px);
  }
}
.drawer-blur {
  width: 100%;
  opacity: 0.6;
  background-color: $dark-gray-5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  min-height: 100vh;
}
.nav-drawer {
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: $colorN00;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
  width: 250px;
}
.background {
  width: 250px;
  height: 40px;
  background-color: $colorN00;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.menu-item {
  margin: 9px 0 10px 17px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.04px;
  text-align: center;
  color: $dark-gray-5;
  font-size: 14px;
}
.menu-item {
  margin: 9px 0 10px 17px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.04px;
  text-align: center;
  color: $dark-gray-5;
  font-size: 14px;
}
.image-arrow {
  margin-right: 11px;
}
.hr {
  width: 100%;
  height: 1px;
  background-color: $gray-1;
}
.side-area-drawer {
  height: 95%;
  position: fixed;
  z-index: 1;
  background-color: $colorN10;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 30px;
  width: 32%;
  min-width: 345px;
  right: 0;
  top: 50px;
  display: flex;
  justify-content: center;
}
.side-area {
  display: flex;
  flex-direction: column;
  width: 26%;
  max-width: 326px;
  div:nth-child(n) {
    margin-bottom: 10px;
  }
}
.shop-profile-card {
  max-width: 326px;
}
.details-banner-area {
  width: 100%;
}
.zIndex {
  z-index: 9999;
}

.profile-box,
.performance-box {
  background-color: $colorN00;
  width: 100%;
  display: flex;
  height: 48.5px;
  align-items: center;
  margin-top: 38px;
  justify-content: space-between;
  &-arrow {
    width: 24px;
    height: 24px;
    margin-right: 20px;
    &.opened {
      margin-top: 11px;
      margin-left: auto;
    }
  }
  &-title-position {
    margin-left: 16px;
    font-weight: bold;
    &.opened {
      margin-top: 17px;
      margin-left: 0;
      font-weight: bold;
    }
  }
}

.profile-box {
  &.opened {
    background-color: $colorN00;
    width: 100%;
    height: 166px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  &-icon {
    width: auto;
    height: 70px;
    margin: 16px 16px 12px 16px;
  }
  &-verificated-icon {
    margin-top: 17px;
    margin-left: 5px;
  }
  &-shop-point-title {
    margin-left: 17px;
    font-weight: bold;
    margin-top: 15px;
  }
  &-progress-bar {
    margin-left: 17px;
    width: 80%;
    margin-bottom: 16px;
  }
  .hr {
    width: 100%;
    height: 1px;
    background-color: $gray-1;
  }
}

.performance-box {
  display: block;
  margin: 0 !important;
  &-header {
    height: 48px;
  }
  &.opened {
    background-color: $colorN00;
    width: 100%;
    height: auto;
    align-items: flex-start;
  }
}

@media screen and (max-width: 1200px) {
  .side-area {
    width: 100%;
  }

  .profile-box {
    margin-top: 0;
  }
}

@media screen and (max-width: 767px) {
  .side-area {
    width: 100%;
    gap: 8px;
    margin-top: 8px;
    max-width: 100%;
    div:nth-child(n) {
      margin-bottom: 0;
    }
  }
  .shop-profile-card {
    margin: 0;
  }
  .details-banner-area {
    width: 100%;
    height: 100%;
  }
  .zIndex {
    z-index: 0;
  }
  .surveyModalContent {
    margin: 16px 0 5px;
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: -0.05px;
    color: #1f1f1f;
  }
}
</style>
